import sweaterTrash from "../assets/prendas/sweaterTrash.jpg";
import sweaterTrash2 from "../assets/prendas/sweaterTrash2.jpg";
import chombaBoris from "../assets/prendas/chombaBoris.jpg";
import chombaBoris2 from "../assets/prendas/chombaBoris2.jpg";
import camisaBoris from "../assets/prendas/camisaBoris.jpg";
import camisaBoris2 from "../assets/prendas/camisaBoris2.jpg";

export const products = [
    {
        id: 1,
        images: [sweaterTrash, sweaterTrash2],
        name: "Sweater trash",
        price: "116000",
        drop: '0001'
    },
    {
        id: 2,
        images: [chombaBoris, chombaBoris2],
        name: "Chomba Boris",
        price: "124000",
        drop: '0001',
    },
    {
        id: 3,
        images: [camisaBoris, camisaBoris2],
        name: "Camisa Boris",
        price: "135000",
        drop: '0001',
    },
];